import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import React from 'react';

function CommentDetails({ resultsAndCommentsValue }) {
    if (resultsAndCommentsValue?.commentViewModel?.lastUpdateDate?.length == 0 || resultsAndCommentsValue?.commentViewModel?.lastUpdateDate == null) {
        const commentsElement = document.getElementById('comments')
        if (commentsElement) {
            commentsElement.value = " "
        }
    }
    return (
        

        
        <Col>
            <Row xs={2}>
                <Col>Latest Tagetik import date</Col>
                {resultsAndCommentsValue?.tagetikImport != null && <Col>{ new Date(resultsAndCommentsValue?.tagetikImport).toLocaleString() }</Col>}
            </Row>
            <Row xs={2}>
                <Col>Status</Col>
                <Col>Number of scenario's is {resultsAndCommentsValue?.scenarioSelection?.length}.</Col>
            </Row>
            <Row xs={2}>
                <Col>Draft version</Col> 
                {resultsAndCommentsValue?.draftVersionViewModel != null && <Col>{new Date(resultsAndCommentsValue?.draftVersionViewModel?.lastUpdateDate).toLocaleString() } by {resultsAndCommentsValue?.draftVersionViewModel?.userFullName}</Col>}
            </Row>
            <Row xs={2}>
                <Col>Tagetik import date draft</Col>
                {resultsAndCommentsValue?.dateDraft != null && <Col>{new Date(resultsAndCommentsValue?.dateDraft).toLocaleString()}</Col>}
            </Row>
            <Row xs={2}>
                <Col>Final version</Col>
                {resultsAndCommentsValue?.finalVersionViewModel != null && <Col>{new Date(resultsAndCommentsValue?.finalVersionViewModel?.lastUpdateDate).toLocaleString() } by {resultsAndCommentsValue?.finalVersionViewModel?.userFullName}</Col>}
            </Row>
            <Row xs={2}>
                <Col>Tagetik import date final</Col>
                {resultsAndCommentsValue?.dateFinal != null && <Col>{new Date(resultsAndCommentsValue?.dateFinal).toLocaleString()}</Col>}
            </Row>
            <Row xs={2}>
                <Col>Corrections</Col>
                {resultsAndCommentsValue?.correctionViewModel &&
                    resultsAndCommentsValue.correctionViewModel[0] && (
                        <Col>
                        {resultsAndCommentsValue.correctionViewModel[0].lastUpdateTime != null}
                            {new Date(
                                resultsAndCommentsValue.correctionViewModel[0].lastUpdateTime
                            ).toLocaleString()}{" "}
                            by{" "}
                        {resultsAndCommentsValue.correctionViewModel[0].userName}
                        </Col>
                    )}
            </Row>
            <Row xs={2}>
                <Col>Mitigations</Col>
                {resultsAndCommentsValue?.mitigationLastUpdateViewModel &&
                    resultsAndCommentsValue.mitigationLastUpdateViewModel[0] && (
                    <Col>
                        {resultsAndCommentsValue.mitigationLastUpdateViewModel[0].lastUpdateTime != null }
                            {new Date(
                                resultsAndCommentsValue.mitigationLastUpdateViewModel[0].lastUpdateTime
                            ).toLocaleString()}{" "}
                            by{" "}
                            {resultsAndCommentsValue.mitigationLastUpdateViewModel[0].userName}
                        </Col>
                    )}

            </Row>
            <Row xs={2}>
                <Col>Comment</Col>
                {(resultsAndCommentsValue?.commentViewModel?.lastUpdateDate?.length !== 0 && resultsAndCommentsValue?.commentViewModel?.lastUpdateDate != null) && <Col>{new Date(resultsAndCommentsValue?.commentViewModel?.lastUpdateDate).toLocaleString()} by {resultsAndCommentsValue?.commentViewModel?.userFullName}</Col>}
            </Row>
            <Row xs={2}>
                <Col>Comment</Col>
                <Col> <textarea id='comments' name="comments" rows='3' value={resultsAndCommentsValue?.commentViewModel?.memo} defaultValue=' '></textarea> </Col>
            </Row>
        </Col>
    )
}

export default CommentDetails;